// consolidate the software themed routes to src/packages/platform/project-theme/page-container/src/controllers/project-theme/constants.tsx
// when we migrate the software project theming to business

import { fg } from '@atlassian/jira-feature-gating';

export const getSoftwareContouredThemeRoutes = () => {
	if (fg('jira_list_nin_merge')) {
		return new Set([
			'issue',
			'software-backlog',
			'rapidboard-backlog',
			'software-timeline',
			'software-timeline-classic',
			'software-issue-navigator',
			'software-list',
			'software-list-classic',
			'issue-navigator-classic',
		]);
	}
	return new Set([
		'issue',
		'software-backlog',
		'rapidboard-backlog',
		'software-timeline',
		'software-timeline-classic',
		'software-issue-navigator',
		'issue-navigator-classic',
	]);
};

// delete this on jira_theming_milestone_2 cleanup
export const getSoftwareFullThemeRoutes = () => {
	const capacityRoutes = fg('add_capacity_tab_to_the_board_horizontal_nav')
		? ['software-capacity', 'software-capacity-classic']
		: [];
	if (fg('jira_list_nin_merge')) {
		return new Set([
			'software-boards',
			'rapidboard-board',
			'software-calendar',
			'software-calendar-classic',
			'software-summary',
			'software-summary-classic',
			...capacityRoutes,
		]);
	}
	return new Set([
		'software-boards',
		'rapidboard-board',
		'software-calendar',
		'software-calendar-classic',
		'software-list',
		'software-list-classic',
		'software-summary',
		'software-summary-classic',
		...capacityRoutes,
	]);
};

export const getSoftwareContouredThemeRoutesM2 = () => {
	if (fg('jira_list_nin_merge')) {
		return new Set([
			'issue',
			'software-timeline',
			'software-timeline-classic',
			'software-issue-navigator',
			'software-list',
			'software-list-classic',
			'issue-navigator-classic',
		]);
	}
	return new Set([
		'issue',
		'software-timeline',
		'software-timeline-classic',
		'software-issue-navigator',
		'issue-navigator-classic',
	]);
};

export const getSoftwareFullThemeRoutesM2 = () => {
	const capacityRoutes = fg('add_capacity_tab_to_the_board_horizontal_nav')
		? ['software-capacity', 'software-capacity-classic']
		: [];
	if (fg('jira_list_nin_merge')) {
		return new Set([
			'software-boards',
			'rapidboard-board',
			'software-calendar',
			'software-calendar-classic',
			'software-summary',
			'software-summary-classic',
			'software-backlog',
			'rapidboard-backlog',
			'project-pages',
			'software-form-classic',
			'software-form',
			'software-form-builder-classic',
			'software-form-builder',
			...capacityRoutes,
		]);
	}
	return new Set([
		'software-boards',
		'rapidboard-board',
		'software-calendar',
		'software-calendar-classic',
		'software-list',
		'software-list-classic',
		'software-summary',
		'software-summary-classic',
		'software-backlog',
		'rapidboard-backlog',
		'project-pages',
		'software-form-classic',
		'software-form',
		'software-form-builder-classic',
		'software-form-builder',
		...capacityRoutes,
	]);
};

// delete this on jira_theming_milestone_2 cleanup
export const getSoftwareThemeRoutes = () =>
	new Set([...getSoftwareContouredThemeRoutes(), ...getSoftwareFullThemeRoutes()]);

export const getSoftwareThemeRoutesM2 = () =>
	new Set([...getSoftwareContouredThemeRoutesM2(), ...getSoftwareFullThemeRoutesM2()]);
